import * as React from 'react'
import { Inset } from '@doordash/design-language'
import Button from '@doordash/component-button'
import { OnboardingComponentProps } from '.'

const Link = props => (
  <a {...props} target="_blank" href={props.href}>
    {props.children}
  </a>
)

// This button component navigates to the next section without making any api calls
export const NavigateButtonComponent: React.FC<OnboardingComponentProps> = ({
  templateResponseData,
  data,
  apiPath,
  onChange,
  value,
  ...props
}: OnboardingComponentProps) => {
  const handleButtonClick = () => {
    onChange(!value)
  }

  return (
    <>
      <Inset size={Inset.Sizes.XxxLarge} />
      {props.href ? (
        <Button {...props} tag={Link} href={props.href} />
      ) : (
        <Button onClick={handleButtonClick} {...props} />
      )}
    </>
  )
}
